var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Alert'),_c('div',{staticClass:"container-fluid"},[_c('Siderbar'),_c('main',{attrs:{"id":"main"}},[_vm._m(0),_c('div',{staticClass:"page-heading"},[_c('router-view')],1),_c('Footer')],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"mb-3"},[_c('a',{staticClass:"burger-btn d-block d-xl-none",attrs:{"href":"#"}},[_c('i',{staticClass:"bi bi-justify fs-3"})])])
}]

export { render, staticRenderFns }